import React from 'react'

import Manifold from './Manifold'
import LPG from './LPG'
import _3dTank from './3dTank'
import { TRACKERTYPES } from 'utils/constants'

interface IProps {
  tank: any
}

const Gauge = ({ tank }: IProps) => {
  if (TRACKERTYPES.includes(tank.type)) {
    return <img style={{ width: '100%' }} src="/images/icons/tracker.svg" />
  }
  else {
    switch (tank.type) {
      case 'blereader':
      case 'manifold-r':
      case 'manifold-l':
      case 'manifold':
        // return <img style={{ width: '100%' }} src="/images/icons/beaconlpg.png" />
        return <Manifold tank={tank} />
      case 'pack':
        return <Manifold tank={tank} />
      // case TRACKERTYPES.includes(tank.type):
      //   return <img style={{ width: '100%' }} src="/images/icons/tracker.svg" />
      case 'lpg':
        return <LPG tank={tank} />
      default:
        return <_3dTank tank={tank} />
    }
  }
}

export default React.memo(Gauge)
